import React from 'react';
import { connect } from 'react-redux';

import MenuItemChoice from '../../common/menuitem/MenuItemChoice';
import SpecialItemInformation from './SpecialItemInformation';
import SpecialItemInstructions from './SpecialItemInstructions';
import SpecialItemSubmitButton from './SpecialItemSubmitButton';
import FoodItemAddonSelection from '../../fooditems/FoodItemAddonSelection';

import { cartItemLoadSpecialItems } from '../../../actions/cartItem';
import { setSpecialPanel } from '../../../actions/panels';

import generateSpecialPrice from '../../../utils/generateSpecialPrice';

class ViewFoodItem extends React.Component {

    constructor(props) {
        super(props);

        this.isSelected = this.isSelected.bind(this);
        this.isMultipleSelected = this.isMultipleSelected.bind(this);
        this.updateSingleChoiceSelection = this.updateSingleChoiceSelection.bind(this);
        this.updateMultipleChoiceSelection = this.updateMultipleChoiceSelection.bind(this);

        this.state = {
            specialFoodItem: {},
            index: 0,
        };
    }

    isSelected(choice_id, item_id) {

        const selectedChoice = this.props.cartItem.items[this.props.index].choices.find((theChoice) => {
            return theChoice.id == choice_id;
        });

        return selectedChoice.item_id == item_id;
    }

    isMultipleSelected(choice_id, item_id) {

        const selectedChoice = this.props.cartItem.items[this.props.index].choices.find((theChoice) => {
            return theChoice.id == choice_id;
        });
        
        // iterate through the items and determine if it's there
        let isFound = false;
        selectedChoice.items.forEach((theItem) => {
            if (theItem == item_id) {
                isFound = true;
            }
        });
        
        return isFound;
    }

    updateMultipleChoiceSelection(choice_id, selections, choices, selection) {
        const updatedSpecialItems = this.props.cartItem.items.map((theCartItem, theIndex) => {
            if (this.props.index == theIndex) {

                theCartItem.choices = theCartItem.choices.map((theCartChoice) => {
                    if (theCartChoice.id == choice_id) {
                        
                        // set the initial variables
                        let newChoiceItemName = "";
                        let items = [];

                        const selectedChoice = this.props.cartItem.items[this.props.index].choices.find((theCartChoice) => {
                            return theCartChoice.id == choice_id;
                        });

                        const selectedItem = selectedChoice.items.find((theItem) => {
                            return theItem == selection.id;
                        });

                        if (selectedItem) {

                            // it is present, remove it from the list
                            items = selectedChoice.items.filter((theItem) => theItem != selection.id);
                        }
                        else if (selectedChoice.items.length < selectedChoice.max_choices) {

                            //add the item
                            items = selectedChoice.items.concat(selection.id);
                        }
                        else {
                            items = selectedChoice.items;
                        }

                        // get the item name
                        items.forEach((theItem) => {
                            selections.forEach((theChoiceItem) => {
                                if (theItem == theChoiceItem.id) {
                                    if (newChoiceItemName == "") {
                                        newChoiceItemName = theChoiceItem.name;
                                    }
                                    else {
                                        newChoiceItemName += ", "+theChoiceItem.name;
                                    }
                                    if (theChoiceItem.price > 0) {
                                        newChoiceItemName += " - "+theChoiceItem.price;
                                    }
                                }
                            });
                        });

                        if (newChoiceItemName == "") {
                            newChoiceItemName = "No Items selected.";
                        }

                        theCartChoice.items = items;
                        theCartChoice.item_name = newChoiceItemName;
                    }

                    return theCartChoice;
                });
            }

            return theCartItem;
        });

        this.props.dispatch(cartItemLoadSpecialItems(updatedSpecialItems));
    }

    updateSingleChoiceSelection(choice_id, selection) {

        const updatedSpecialItems = this.props.cartItem.items.map((theCartItem, theIndex) => {
            if (this.props.index == theIndex) {

                // this is our item, let's update the choice!
                theCartItem.choices = theCartItem.choices.map((theCartChoice) => {
                    if (theCartChoice.id == choice_id) {
                        theCartChoice.item_name = selection.name;
                        theCartChoice.item_id = selection.id;
                        theCartChoice.item_price = selection.price;
                    }

                    return theCartChoice;

                });

            }

            return theCartItem;
        });

        this.props.dispatch(cartItemLoadSpecialItems(updatedSpecialItems));
    }

    updateSpecialItems(curSpecialItem) {
        let curSpecial = this.props.cartItem;

        // update the specific item
        curSpecial.items[this.props.index] = curSpecialItem;
        this.props.dispatch(cartItemLoadSpecialItems(curSpecial.items));
    }

    renderFoodItemPricesAndChoices() {
        if (this.props.cartItem.items[this.props.index].choices && this.props.specialFoodItem.fooditem && this.props.cartItem.items[this.props.index].choices.length > 0 && this.props.specialFoodItem.fooditem.choices.length > 0) {

            return (
                <div>
                    {this.props.specialFoodItem.fooditem.choices.map((theChoice) => {

                        return (
                            <MenuItemChoice
                                key={theChoice.id}
                                onChoicePress={() => { 
                                    this.props.navigation.navigate('ViewSpecialFoodItemChoices', {
                                        currentChoice: JSON.stringify(theChoice),
                                        index: this.props.index,
                                    });
                                }}
                                choice={theChoice}
                                isSelected={this.isSelected}
                                isMultipleSelected={this.isMultipleSelected}
                                updateSingleChoiceSelection={this.updateSingleChoiceSelection}
                                updateMultipleChoiceSelection={this.updateMultipleChoiceSelection}
                                selection={this.props.cartItem.choices.find((theSelection) => {
                                    return theChoice.id == theSelection.id;
                                })}
                            >
                                {theChoice.name}
                            </MenuItemChoice>
                        );
                    })}
                </div>
            )
        }
    }

    addSpecialFoodItemAddon(addon_id) {
        this.updateSpecialItems({
            ...this.props.cartItem.items[this.props.index],
            addons: this.props.cartItem.items[this.props.index].addons.concat(addon_id)
        });
    }

    removeSpecialFoodItemAddon(addon_id) {
        this.updateSpecialItems({
            ...this.props.cartItem.items[this.props.index],
                addons: this.props.cartItem.items[this.props.index].addons.filter((addon) => addon != addon_id)
        });
    }

    renderFoodItemAddons() {
        if (this.props.specialFoodItem.fooditem && this.props.specialFoodItem.fooditem.addons.length > 0) {
            return (
                <div>
                    <div className="section-title">
                        <p className="selectionTitleText">ADD-ONS</p>
                    </div>
                    {this.props.specialFoodItem.fooditem.addons.map((theAddon) => {
                        return (
                            <FoodItemAddonSelection
                                onPress={() => {
                                    
                                    if (this.props.cartItem.items[this.props.index].addons.some((addon) => addon == theAddon.id)) {
        
                                        // it is there, remove
                                        this.removeSpecialFoodItemAddon(theAddon.id);
                                    }
                                    else {
        
                                        // it isn't there, add it
                                        this.addSpecialFoodItemAddon(theAddon.id);
                                    }
                                }}
                                checked={this.props.cartItem.items[this.props.index].addons.some((addon) => addon == theAddon.id)}
                                key={theAddon.id}
                                addon={theAddon}
                            >
                                {theAddon.name} {(theAddon.price > 0) ? ' - '+theAddon.price : ''}
                            </FoodItemAddonSelection>
                        );
                    })}
                </div>
            );
        }
    }

    render() {
        return (
            <div>
                <div className="menu-item-window">
                    
                    <SpecialItemInformation 
                        type="fooditem"
                        item={this.props.specialFoodItem} 
                    />
                        
                    {this.renderFoodItemPricesAndChoices()}
                    {this.renderFoodItemAddons()}

                    <SpecialItemInstructions 
                        placeholder="Any special instructions?"
                        value={this.props.cartItem.items[this.props.index].instructions}
                        onChange={(e) => {
                            this.updateSpecialItems({
                                ...this.props.cartItem.items[this.props.index],
                                instructions: e.target.value
                            });
                        }}
                    />

                    <p className="disclaimer">
                        Please note: Addons and substitutions requested via special
                        instructions that are subject to extra pricing may not be honoured by the 
                        restaurant.
                    </p>
                </div>
                <div className="fixed-wrapper-for-add-to-order">

                    <SpecialItemSubmitButton
                        onButtonPress={() => this.props.dispatch(setSpecialPanel('info'))}
                        price={generateSpecialPrice(this.props.special, this.props.cartItem)}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        cartItem: state.cartItem,
        special: state.currentMenuItem.item,
    };
};

export default connect(mapStateToProps)(ViewFoodItem);
